/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AssetDependantResponse } from './AssetDependantResponse';
import {
    AssetDependantResponseFromJSON,
    AssetDependantResponseFromJSONTyped,
    AssetDependantResponseToJSON,
    AssetDependantResponseToJSONTyped,
} from './AssetDependantResponse';

/**
 * 
 * @export
 * @interface AssetDependantsResponse
 */
export interface AssetDependantsResponse {
    /**
     * 
     * @type {string}
     * @memberof AssetDependantsResponse
     */
    clientId: string;
    /**
     * 
     * @type {Array<AssetDependantResponse>}
     * @memberof AssetDependantsResponse
     */
    dependants: Array<AssetDependantResponse>;
}

/**
 * Check if a given object implements the AssetDependantsResponse interface.
 */
export function instanceOfAssetDependantsResponse(value: object): value is AssetDependantsResponse {
    if (!('clientId' in value) || value['clientId'] === undefined) return false;
    if (!('dependants' in value) || value['dependants'] === undefined) return false;
    return true;
}

export function AssetDependantsResponseFromJSON(json: any): AssetDependantsResponse {
    return AssetDependantsResponseFromJSONTyped(json, false);
}

export function AssetDependantsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): AssetDependantsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'clientId': json['clientId'],
        'dependants': ((json['dependants'] as Array<any>).map(AssetDependantResponseFromJSON)),
    };
}

export function AssetDependantsResponseToJSON(json: any): AssetDependantsResponse {
    return AssetDependantsResponseToJSONTyped(json, false);
}

export function AssetDependantsResponseToJSONTyped(value?: AssetDependantsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'clientId': value['clientId'],
        'dependants': ((value['dependants'] as Array<any>).map(AssetDependantResponseToJSON)),
    };
}

